<template>
  <div>
    <label>{{ statusMessage }}</label>
    <div class="col-md-4">
      <div class="form-group">
        <label for="investor_offering">Select an Offering</label>
        <select id="investor_offering" class="form-control" name="investor_offering" required
          v-model="formData.offeringId">
          <option value="all">All</option>
          <option v-for="option in offerings" :value="option.id">{{ option.name }}</option>
        </select>
        <br />
        <label for="report_name">Report Name</label>
        <input id="report_name" type="text" class="form-control" name="report_name" placeholder="Report Name" required
          v-model="formData.reportName">
      </div>
      <div>
        <div class="form-group">
          <label>Start Date</label>
          <datepicker class="date-picker" v-model="formData.reportStartDate" format="yyyy-MM-dd" name="report_start_date">
          </datepicker>
        </div>
        <div class="form-group">
          <label>End Date</label>
            <datepicker class="date-picker" v-model="formData.reportEndDate" format="yyyy-MM-dd" name="report_start_date">
          </datepicker>
        </div>
        <button type="button" @click="onClick($event)" :disabled="notReadyToGenerateReport">Run Report</button>
       
        <!-- <confirm-modal :show-confirm="showConfirm" confirm-message="Do you want to create this report?"
          @ok="confirmReport" @cancel="cancelReport"></confirm-modal> -->
        <br /><br />
      </div>
    </div>
    <div class="col-md-8">
      <div class="col-md-6">
        <b>Default Fields</b>
        <div class="row-checkfields" v-for="(field, index) in fields" :key="index">
          <input
            class="row-checkfields-input"
            type="checkbox" 
            checked 
            :id="field.value" 
            :value="field.value" 
            @change="handleSelectField(field.value)"
          />
          <label class="row-checkfields-label"  :for="field.value">{{ field.label }}</label>
        </div>
      </div>
      <div class="col-md-6">
        <b>Additional Fields</b>
        <div class="row-checkfields" v-for="(field, index) in additionalFields" :key="index">
          <input
            class="row-checkfields-input" type="checkbox"
            :id="field.value" :value="field.value"
            @change="handleSelectField(field.value)"
          />
          <label class="row-checkfields-label" :for="field.value">{{ field.label }}</label>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import axios from "axios";
import Datepicker from 'vuejs-datepicker';
import moment from "moment"
import { fields, additionalFields } from '../../constants/transactionReport'

export default {
  components: {
    Datepicker
  },
  data() {
    return {
      formData: {
        emdId : this.emdId,
        reportStartDate: new Date().toISOString().slice(0, 10),
        reportEndDate: new Date().toISOString().slice(0, 10),
        offeringId: 'all',
        reportName: '',
        selectedFields: fields.map(field => field.value),
      },
      showConfirm: false,
      statusMessage: '',
      showStatusMessage: false,
      validated: false,
      fields,
      additionalFields
    }
  },
  props: {
    offerings: Array,
    emdId: {
      type: Number,
      default: 0
    },
    redirectUrl: '',
  },
  computed: {
    notReadyToGenerateReport() {
      const {
        offeringId,
        reportStartDate,
        reportEndDate,
        reportName,
      } = this.formData;
      return offeringId === 0 || reportStartDate === '' || reportEndDate === '' || reportName === '';
    },
  },
  methods: {
    transferData() {
      window.location.href = this.redirectUrl
    },
    onClick: function (event) {
      if (
          this.notReadyToGenerateReport
        ) {
        this.statusMessage = 'Error: Please fill in all the required fields.';
        return;
      }
      this.statusMessage = '';
      axios.post('runTransaction', {
        ...this.formData,
        reportStartDate: moment(this.formData.reportStartDate).format('yyyy-MM-DD'),
        reportEndDate: moment(this.formData.reportEndDate).format('yyyy-MM-DD')
      })
        .then(response => {
          this.statusMessage = response.data.statusMessage
          if(response.data.status === 'success') {
          //   this.$emit('success');
            window.location.href = this.redirectUrl
          }
          if(response.data.status === 'error') {
            this.showErrors(response.data.errors)
          }
          return Promise.resolve()
        })
    },
    handleSelectField(checkedValue) {
      if (this.formData.selectedFields.includes(checkedValue)) {
        this.formData.selectedFields = this.formData.selectedFields.filter((value) => value !== checkedValue);
      } else {
        this.formData.selectedFields.push(checkedValue);
      }
    }
  },
  showErrors(errors) {
      let message = ""
      Object.values(errors).forEach( val => message += val[0])
      this.statusMessage = message
      this.showStatusMessage = true
    }
}
</script>